import React, { useState } from "react";
import wechatQR from "./wechatqr.jpg";

export default function WeChatChatButton() {
  const [showQR, setShowQR] = useState(false);

  return (
    <div style={{ position: "fixed", bottom: "100px", right: "20px", zIndex: 1000 }}>
      {/* زر المحادثة */}
      <button
        onClick={() => setShowQR(!showQR)}
        style={{
          backgroundColor: "#07C160",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          color: "#fff",
          fontSize: "24px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        💬
      </button>

      {/* نافذة الكود */}
      {showQR && (
        <div
          style={{
            position: "absolute",
            bottom: "70px",
            right: 0,
            background: "#fff",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            textAlign: "center",
          }}
        >
          <p style={{ marginBottom: "8px", fontSize: "14px" }}>
          </p>
          <img src={wechatQR} alt="WeChat QR" width={350} height={350} />
        </div>
      )}
    </div>
  );
}
